/**
 * API Configuration for the Payslip System
 *
 * This file handles dynamic API URL configuration for different environments:
 * - Local development (localhost)
 * - LAN access (device IP address)
 * - Production (if needed)
 */

// Function to get the current hostname/IP from the browser
const getCurrentHost = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return 'localhost';
};

// Function to determine the API URL based on current environment
const getApiUrl = (): string => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    // Server-side rendering or build time - use environment variable or default
    return process.env.REACT_APP_API_URL || 'https://localhost:8080/api' || 'http://localhost:8080/api';
  }

  const currentHost = getCurrentHost();

  // If accessing via localhost, use localhost for API
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return 'http://localhost:8080/api' ;
  }

  // Use same protocol as the page (https when served over HTTPS, avoids Mixed Content)
  const protocol = window.location.protocol;
  return `${protocol}//${currentHost}/api`;
};

// Export the API URL
export const API_BASE_URL = getApiUrl();

// Export individual service URLs
export const EMPLOYEE_API_URL = `${API_BASE_URL}/employee-management`;
export const CONSTRUCTION_WORKER_API_URL = `${API_BASE_URL}/construction-worker-management`;
export const FILE_UPLOAD_API_URL = API_BASE_URL;